// extracted by mini-css-extract-plugin
module.exports = {"mainImgContainer":"MainBanner_mainImgContainer__Z9a3O","halfBg":"MainBanner_halfBg__GUBhg","linkWrapper":"MainBanner_linkWrapper__SbaCc"};